(() => {
  const { gsap, ScrollTrigger } = window;

  if (!gsap || !ScrollTrigger) return;

  gsap.registerPlugin(ScrollTrigger);

  const mediaQueries = {
    desktop: '(min-width: 1300px)',
    tablet: '(min-width: 750px) and (max-width: 1299px)',
    mobile: '(max-width: 749px)',
    reduceMotion: '(prefers-reduced-motion: reduce)',
  };

  const createMotionScope = (setupAnimations) => {
    const media = gsap.matchMedia();

    media.add(mediaQueries, (context) => {
      if (context.conditions.reduceMotion) return;

      setupAnimations(context.conditions);
    });
  };

  const isAnimationEnabled = (element) => !element.closest('[data-gsap-animation="false"]');

  // Targets shared media-block images except Custom Editorial and dedicated Editorial-preset images.
  const initScaledImages = () => {
    const wrappers = gsap.utils
      .toArray('.gsap-img-wrapper')
      .filter(
        (wrapper) =>
          isAnimationEnabled(wrapper) &&
          !wrapper.closest('.custom-editorial') &&
          !wrapper.closest('.media-with-content[data-gsap-image-animation="editorial"]')
      );
    if (!wrappers.length) return;

    createMotionScope(({ mobile }) => {
      wrappers.forEach((wrapper) => {
        const image = wrapper.querySelector('.gsap-img-scale');
        if (!image) return;

        gsap.fromTo(
          image,
          {
            // scale: mobile ? 1.1 : 1.06,
            // scale: 1.1,
            yPercent: mobile ? -7 : -5,
          },
          {
            scale: 1.1,
            yPercent: mobile ? 7 : 5,
            ease: 'none',
            scrollTrigger: {
              trigger: wrapper,
              start: 'top 80%',
              end: 'bottom top',
              scrub: 1,
              markers: false,
            },
          }
        );
      });
    });
  };

  // Targets the media image in the Editorial media-with-content preset.
  const initEditorialPresetImageAnimation = () => {
    const wrappers = gsap.utils
      .toArray('.media-with-content[data-gsap-image-animation="editorial"] .gsap-img-wrapper')
      .filter(isAnimationEnabled);
    if (!wrappers.length) return;

    createMotionScope(({ mobile }) => {
      wrappers.forEach((wrapper) => {
        const image = wrapper.querySelector('.gsap-img-scale');
        if (!image) return;

        gsap.fromTo(
          image,
          {
            scale: mobile ? 1.07 : 1.12,
            yPercent: mobile ? -5 : -7,
          },
          {
            // scale: 2,
            scale: 1.015,
            yPercent: mobile ? 5 : 7,
            ease: 'none',
            scrollTrigger: {
              trigger: wrapper,
              start: 'top bottom',
              end: 'bottom top',
              scrub: mobile ? 0.8 : 1.1,
              markers: false,
            },
          }
        );
      });
    });
  };

  // Targets media images in the Custom Editorial section.
  const initTranslatedEditorialImages = () => {
    const wrappers = gsap.utils
      .toArray('.custom-editorial .gsap-img-wrapper')
      .filter(isAnimationEnabled);
    if (!wrappers.length) return;

    createMotionScope(({ mobile }) => {
      wrappers.forEach((wrapper) => {
        const image = wrapper.querySelector('.gsap-img-scale');
        if (!image) return;

        gsap.fromTo(
          image,
          { 
            yPercent: mobile ? -2 : -2.5 },
          {
            scale: 1.15,
            yPercent: mobile ? 4 : 4,
            ease: 'none',
            scrollTrigger: {
              trigger: wrapper,
              start: 'top center',
              end: 'bottom top',
              scrub: 1,
              markers: false,
            },
          }
        );
      });
    });
  };

  // Targets image elements in the Hero section.
  const initHeroImageAnimation = () => {
    const heroWrappers = gsap.utils
      .toArray('.gsap-img-transform-wrapper')
      .filter(isAnimationEnabled);
    if (!heroWrappers.length) return;

    createMotionScope((conditions) => {
      const { mobile, tablet } = conditions;
      const animation = mobile
        ? { fromY: 0, toY: 100 }
        : tablet
          ? { fromY: 0, toY: 70 }
          : { fromY: 0, toY: 100 };

      heroWrappers.forEach((wrapper) => {
        const heroImages = wrapper.querySelectorAll('.gsap-img-transform');
        if (!heroImages.length) return;

        gsap.fromTo(
          heroImages,
          { y: animation.fromY },
          {
            y: animation.toY,
            ease: 'none',
            scrollTrigger: {
              trigger: wrapper,
              start: 'top top',
              end: 'bottom top',
              scrub: 0.5,
              markers: false,
            },
          }
        );
      });
    });
  };

  // Targets the image in the Custom Banner section.
  const initCustomBannerImageAnimation = () => {
    const bannerSections = gsap.utils
      .toArray('.custom-banner')
      .filter(isAnimationEnabled);
    if (!bannerSections.length) return;

    createMotionScope(({ mobile }) => {
      bannerSections.forEach((section) => {
        const bannerImage = section.querySelector('.custom-banner__gsap-image');
        if (!bannerImage) return;

        gsap.fromTo(
          bannerImage,
          {
            yPercent: mobile ? -4 : -6,
          },
          {
            yPercent: mobile ? 4 : 6,
            ease: 'none',
            scrollTrigger: {
              trigger: section,
              start: 'top bottom',
              end: 'bottom top',
              scrub: mobile ? 0.8 : 1.1,
              invalidateOnRefresh: true,
              markers: false,
            },
          }
        );
      });
    });
  };

  initScaledImages();
  initEditorialPresetImageAnimation();
  initTranslatedEditorialImages();
  initHeroImageAnimation();
  initCustomBannerImageAnimation();
})();
